export default __webpack_public_path__ + "static/media/img-0633-moldova-half-price.05fe4204.png";